var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c(
        "keep-alive",
        { attrs: { include: _vm.$store.state.nav.routes } },
        [_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e()],
        1
      ),
      _vm._v(" "),
      !_vm.$route.meta.keepAlive ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _vm.moduleConfig.M_HUMAN_CAR && _vm.mobile && _vm.isCheckRoute
        ? _c(
            "div",
            {
              ref: "contact",
              staticClass: "contact",
              class: _vm.showAvatar ? "" : "contact_active",
            },
            [
              _c("div", { staticClass: "contact_info" }, [
                _c(
                  "div",
                  {
                    staticClass: "contactAvart",
                    class: _vm.showAvatar ? "" : "active",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.moveAvatar.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("Svga", {
                      staticClass: "svga",
                      attrs: {
                        "svga-img": _vm.call,
                        width: 200,
                        height: 200,
                        elid: "1",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }